import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import Footer from '../component/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import SelectDropDown from '../component/SelectDropDown'
import InputField from '../component/InputField'
import Form from 'react-bootstrap/Form';
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import Header from '../component/Header'
import RegistrationService from '../services/registration'
import AlertMsg from '../component/AlertMsg';
import DatePicker from '../component/DatePicker'

const PurchaseRegistrationDealer = () => {
  //USE STATE
  const [isProduct, setIsProduct] = useState({ id: "", title: "" })
  const [isProductList, setIsProductList] = useState([])
  const [isPersona, setIsPersona] = useState({ id: "", title: "" })
  const [isPersonaList, setIsPersonaList] = useState([]);
  const [isInfluencer, setIsInfluencer] = useState({ id: "", title: "" })
  const [isInfluencerList, setInfluencerList] = useState([]);
  const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
  const [showAlert, setShowAlert] = useState(false);
  const [purchase, setPurchase] = useState(
      {
          mobile: '',
          unitPrice: '',
          totalBag: '',
          purchaseDate: '',
          customerName:''
      }
  )
  const [productNameValidationError, setProductNameValidationError] = useState('');
  const [personaValidationError, setpersonaValidationError] = useState('');
  const [influencerValidationError, setInfluencerValidationError] = useState('');
  const [unitPriceValidationError, setUnitPriceValidationError] = useState('');
  const [bagPurchasedValidationError, setBagPurchaseValidationError] = useState('');
  const [purchaseDateValidationError, setPurchaseDateValidationError] = useState('');
  const [phoneValueValidationError, setPhoneValueValidationError] = useState('');
  const [customerNameValidationError, setCustomerNameValidationError] = useState('');
  //USEEFECT
  //Persona
  useEffect(() => {
      const hierarchiesFetchData = async () => {
          try { 
              const selectedOrg=2
              const hierchiesFetchDataResponse = await RegistrationService.getHierarchies(selectedOrg);
              const hierchiesList = hierchiesFetchDataResponse.response.hierarchiesDetails.map((item) => ({
                  id: item.id,
                  title: item.name
              }));
              setIsPersonaList(hierchiesList);
          } catch (error) {
              console.error("Error fetching hierarchies:");

          }
      };

      hierarchiesFetchData();
  }, []);
   //Influencer
  
  //Product
  useEffect(() => {
      const productFetchData = async () => {
          try {
              const token = localStorage.getItem('access_token');
              const productFetchDataResponse = await RegistrationService.getProductNames(token);
              const productList = productFetchDataResponse.response.ProductDetails.map((item) => ({
                  id: item.id,
                  title: item.product_name
              }));
              setIsProductList(productList)
          }
          catch (e) {
              console.error("e")

          }
      }
      productFetchData()
  }, [])

  //Influencer

  useEffect(() => {
      const influencerFetchData = async () => {
        if(isPersona.id)
        {
          try { 
               const token = localStorage.getItem('access_token');
              const influencerFetchDataResponse = await RegistrationService.getInfluencers(isPersona.id,token);
              const influencerList = influencerFetchDataResponse.response.saleContractorDetails.map((item) => ({
                    id: item.contractor_id,
                    title: item.full_name

            }));
            setInfluencerList(influencerList)
             
          }
          catch (e) {
            console.error("e")

        }
    }

      }
      influencerFetchData()
  }, [isPersona])

  //Function
  const handleProductChange = (selectedValue) => {
      setIsProduct(selectedValue);
  }
  const handlePersonaChange = (selectedValue) => {
      setIsPersona(selectedValue)
  }
  const handleInfluencerChange = (selectedValue) => {
      setIsInfluencer(selectedValue)
  }
  const handlePurchaseRegistrationInput = (e) => {
      setPurchase({ ...purchase, [e.target.name]: e.target.value })
  }
  //Purchase Registration Submit
  const handlePurchaseRegistration = async () => {
      const validations = [
          { value: isProduct.id, setter: setProductNameValidationError, message: 'Product Name is required.' },
          { value: isPersona.id, setter: setpersonaValidationError, message: 'Persona is required.' },
          { value: isPersona.id, setter: setInfluencerValidationError, message: 'Influencer is required.' },
          { value: purchase.unitPrice, setter: setUnitPriceValidationError, message: 'Unit Price is required.' },
          { value: purchase.totalBag, setter: setBagPurchaseValidationError, message: 'Total Bag Purchased is required.' },
          { value: purchase.purchaseDate, setter: setPurchaseDateValidationError, message: 'Purchase Date is required.' },
          { value: purchase.mobile, setter:setPhoneValueValidationError, message: 'Mobile No is required.' },
          { value:purchase.customerName, setter:setCustomerNameValidationError, message: 'Customer Name is required.'}
          
      ]
      validations.forEach(({ value, setter, message }) => {
          if (!value) {
            setter(message);
          }
          else {
              setter(''); // Clear the error message
          }
        });
        try {
            const token = localStorage.getItem('access_token');
            const externaID = JSON.parse(localStorage.getItem('userData'));
            const payload = {
                 customer_name: purchase.customerName,
                 hidden_unit: 0,
                 mobile_number: purchase.mobile,
                 product_master_id: isProduct.id,
                 sale_date: purchase.purchaseDate,
                 select_contractor : isInfluencer.id,
                 tonnage_sold: parseInt(purchase.totalBag),
                 unit_price: parseInt(purchase.unitPrice),
                 id_extern01: externaID.id_extern01
            };
            
            const res = await RegistrationService.dealerPurchaseRegistration(payload, token);
            if (res.success){
                if (res.response.status === true) {
                setShowAlert(true)
                setIsLoginSuccess({ isLogin: true, text: res.response.message })
            }
            else{
                setShowAlert(true)
                setIsLoginSuccess({ isLogin: false, text: res.response.message })
            }
        }
        } catch (error) {
            console.error('Error submitting purchase registration:');
        }
    };
  return (
      <>
          
          <BreadCrumbSecttion pageTitle="Purchase Registration Dealer" currentPageName="Purchase Registration Dealer" />
          <section className='padTop50'>
              <Container>
                  <Row className='justify-content-center align-item-center h-100'>
                      <Col xs={12} >
                          <div className='userInfoBox'>
                              <div className='dashboard-title'>
                                  <h4>Please Register Your Purchase</h4>
                              </div>
                              <div className="dashboard-details">
                                  <Row>
                                      <Col xs={12} lg={3}>
                                          <SelectDropDown
                                              labelName="Product Name"
                                              requiredStar='*'
                                              options={isProductList}
                                              setSelectedValue={setIsProduct}
                                              selectedValue={isProduct}
                                              onChange={handleProductChange}
                                          />
                                          {productNameValidationError && (
                                              <div className="error-message">{productNameValidationError}</div>
                                          )
                                          }
                                      </Col>
                                      <Col xs={12} lg={3}>
                                          <SelectDropDown
                                              labelName="Persona"
                                              requiredStar='*'
                                              options={isPersonaList}
                                              setSelectedValue={setIsPersona}
                                              selectedValue={isPersona}
                                              onChange={handlePersonaChange}
                                          />
                                          {personaValidationError && (
                                              <div className="error-message">{personaValidationError}</div>
                                          )

                                          }
                                      </Col>
                                      <Col xs={12} lg={3}>
                                          <SelectDropDown
                                              labelName="Choose Influencer"
                                              requiredStar='*'
                                              options={isInfluencerList}
                                              setSelectedValue={setIsInfluencer}
                                              selectedValue={isInfluencer}
                                              onChange={handleInfluencerChange}
                                              
                                          />
                                          {influencerValidationError && 
                                                (<div className="error-message">{influencerValidationError}</div>)
                                              }
                                      </Col>
                                      <Col xs={12} lg={3}>
                                          <InputField
                                              inputFieldLabel="Customer Name"
                                              requiredStar='*'
                                              name="customerName"
                                              value={purchase.customerName}
                                              onChange={handlePurchaseRegistrationInput} />
                                            {customerNameValidationError && (
                                                <div className='error-message'>{customerNameValidationError}</div>
                                            )}
                                              
                                      </Col>
                                      <Col xs={12} lg={3}>
                                          <InputField
                                              inputFieldLabel="Phone Number"
                                              requiredStar='*'
                                              name="mobile"
                                              value={purchase.mobile}
                                              onChange={handlePurchaseRegistrationInput} />
                                         {phoneValueValidationError && (
                                                  <div className='error-message'>{phoneValueValidationError}</div>
                                              )}     
                                      </Col>
                                      
                                      <Col xs={12} lg={3}>
                                          <InputField
                                              inputFieldLabel="Unit price"
                                              requiredStar="*"
                                              name="unitPrice"
                                              value={purchase.unitPrice}
                                              onChange={handlePurchaseRegistrationInput} />
                                              {unitPriceValidationError && (
                                                  <div className='error-message'>{unitPriceValidationError}</div>
                                              )}
                                              
                                      </Col>
                                      <Col xs={12} lg={3}>
                                          <InputField
                                              inputFieldLabel="Total Bag Purchased"
                                              requiredStar="*"
                                              name="totalBag"
                                              value={purchase.totalBag}
                                              onChange={handlePurchaseRegistrationInput} />
                                              {bagPurchasedValidationError &&
                                              (<div className='error-message'>{bagPurchasedValidationError}</div>)
                                              }
                                      </Col>
                                      <Col xs={12} lg={3}>
                                          <DatePicker
                                            inputFieldLabel="Purchase Date"
                                            requiredStar="*"
                                            onChange={handlePurchaseRegistrationInput}
                                            value={purchase.purchaseDate}
                                            name='purchaseDate'
                                            />
                                            {purchaseDateValidationError &&
                                            (<div className='error-message'>{purchaseDateValidationError}</div>)
                                            }
                                      </Col>
                                      <Col xs={12} lg={3} className='mt-4'>
                                          <PrimaryGradientButton
                                              buttonText="Submit"
                                              onClick={handlePurchaseRegistration} />
                                      </Col>
                                      <Col xs={12} className='mt-3'>
                                      <div className='alertBoxWrap'>
                                          {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                              heading={isLoginSuccess.heading}
                                              text={isLoginSuccess.text}
                                          />
                                          }
                                          </div>
                                      </Col>
                                  </Row>
                              </div>
                          </div>
                      </Col>
                  </Row>
              </Container>
          </section>
         
      </>
  )
}

export default PurchaseRegistrationDealer